<div class="page">
  @if (mission) {
    <app-section-toolbar
      [sectionTitle]="'MISSION.TEAM' | translate"
      [isComplete]="isTeamComplete()"
      [addLabel]="'UI.ADD.TEAM_MEMBER' | translate"
      (back)="backToMissionConfig()"
      (toggleStatus)="toggleTeamStatus()"
      (add)="openTeamModal()">
    </app-section-toolbar>
  }

  @if (show) {
    <section class="card">
      @if (missionTeams?.length) {
        <table class="data-table">
          <thead>
            <tr>
              <th>{{ 'TEAM.TEAM_MEMBER' | translate }}</th>
              <th class="cell-center">{{ 'TEAM.MISSION_LEADER' | translate }}</th>
              <th class="cell-center">{{ 'TEAM.IN_TRAINING' | translate }}</th>
              <th>{{ 'TEAM.LOCATION' | translate }}</th>
              <th>{{ 'TEAM.DEVICE' | translate }}</th>
              <th>{{ 'TEAM.LAST_UPDATE' | translate }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @for (team of missionTeams; track team) {
              <tr>
                <td>
                  <span class="member">
                    <span class="cell-strong">{{ team.teamMemberFirstName }} {{ team.teamMemberName }}</span>
                    @if (team.teamMemberId?.toUpperCase().startsWith('EXT')) {
                      <span class="tag">{{ 'TEAM.EXTERNAL' | translate }}</span>
                    }
                  </span>
                </td>
                <td class="cell-center">
                  <input type="checkbox" class="switch"
                    [checked]="team.isMissionLeader"
                    (change)="toggleMissionLeader(team)"
                    [disabled]="isTeamComplete()"/>
                </td>
                <td class="cell-center">
                  <input type="checkbox" class="switch"
                    [checked]="team.isMissionApprentice"
                    (change)="toggleMissionApprentice(team)"
                    [disabled]="isTeamComplete()"/>
                </td>
                <td>{{ team.peoplelocationname }}</td>
                <td class="cell-input">
                  <df-select size="small" ariaLabel="Mobile device"
                    [options]="mobileDeviceOptions"
                    [value]="team.mobileDevicepk"
                    (selectionChange)="setMobileDevice($event, team)"
                    [disabled]="isTeamComplete()" />
                </td>
                <td class="cell-muted">{{ team.lastUpdatedOn | timestampToDate | async }} · {{ team.lastUpdatedBy }}</td>
                <td class="cell-actions">
                  @if (!isTeamComplete()) {
                    <button type="button" class="icon-action danger" [title]="'DELETE' | translate" (click)="removeTeam(team)">
                      <ng-icon name="heroTrash" size="18"/>
                    </button>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      } @else {
        <div class="empty-state">
          <ng-icon name="heroUserGroup" size="32"/>
          <div class="empty-state__title">{{ 'UI.EMPTY.TEAMS' | translate }}</div>
          <div class="empty-state__text">{{ 'UI.EMPTY.TEAMS_MISSION' | translate }}</div>
        </div>
      }
    </section>
  }
</div>

@if (addingTeam) {
  <app-add-team
    [missionTeams]="missionTeams"
    [rolename]="rolename"
    [defaultMarket]="mission.marketname"
    (closeModal)="closeTeamModal($event)"
    (addTeam)="addTeam($event)">
  </app-add-team>
}
